import React from 'react';
import {
  SpinnerRight,
  InflowIcon,
  OutflowIcon,
  TransferIcon,
  BuyIcon,
  SellIcon,
  TrendingUpIcon,
  Reset,
  TableRowInsertBefore,
  TableRowInsertAfter,
  TableColumnInsertBefore,
  TableColumnInsertAfter,
  DuplicateRow,
  DuplicateColumn,
  DeleteRow,
  DeleteColumn,
} from '../assets/mdiIcons';
import MonestrySpinnerAsset from '../assets/MonestrySpinner';
import { LogoNotagline, LogoWhite, SymbolWhite } from '../assets';

export {
  SpinnerRight,
  InflowIcon,
  OutflowIcon,
  TransferIcon,
  BuyIcon,
  SellIcon,
  TrendingUpIcon,
  Reset,
  TableRowInsertBefore,
  TableRowInsertAfter,
  TableColumnInsertBefore,
  TableColumnInsertAfter,
  DuplicateRow,
  DuplicateColumn,
  DeleteRow,
  DeleteColumn,
  LogoNotagline,
  LogoWhite,
  SymbolWhite,
};

export const MonestrySpinner = (props) => <MonestrySpinnerAsset {...props} />;
export default MonestrySpinnerAsset;
